import { call, put, takeLatest } from "redux-saga/effects";
import {
  checkDateFunction,
  createEventAction,
  deleteEventAction,
  editEventAction,
  getAllEventAction,
} from "../api/event-action";
import {
  getAllEvents,
  setDateExistWithinEvent,
  setEventsLoading,
} from "../redux/app/event/event-slice";
import { toast } from "react-toastify";
import {
  setEditBookingDate,
  setEditBookingError,
  setEditBookingLoading,
} from "../redux/app/booking/booking-slice";

export function* createEventSaga(action) {
  try {
    const response = yield call(createEventAction, action.payload);
    if (response) {
      toast.success("Event Created Successfully");
    }
    yield put({ type: "GET_ALL_EVENTS", payload: action.payload });
  } catch (error) {}
}

export function* getAllEventsSaga(action) {
  try {
    yield put(
      setEventsLoading({
        eventsLoading: true,
      })
    );
    const response = yield call(getAllEventAction, action.payload);
    if (response) {
      yield put(
        setEventsLoading({
          eventsLoading: false,
        })
      );
    }
    yield put(getAllEvents({ allEvents: response.data }));
  } catch (error) {}
}

export function* editEventSaga(action) {
  try {
    const response = yield call(editEventAction, action.payload);
    if (response.status === 200) {
      toast.success("Event Updated Successfully");
      yield put({ type: "GET_ALL_EVENTS", payload: action.payload });
    }
  } catch (error) {}
}

export function* deleteEventSaga(action) {
  try {
    console.log(action.payload, "action.payload");

    const response = yield call(deleteEventAction, action.payload);
    if (response.status === 200) {
      toast.success("Event Deleted Successfully");
      yield put({ type: "GET_ALL_EVENTS", payload: action.payload });
    }
  } catch (error) {}
}

export function* dateExistWithinEventSaga(action) {
  try {
    yield put(setEditBookingLoading({ editBookingLoading: true }));
    const response = yield call(checkDateFunction, action.payload);

    if (response.status === 200) {
      yield put(setEditBookingLoading({ editBookingLoading: false }));
      //  console.log("dateExistWithinEventSaga2",response?.data?.status)
      yield put(
        setDateExistWithinEvent({
          DateExistsWithinEvent: response?.data?.status,
        })
      );
      if (response?.data?.status === true) {
        yield put(
          setEditBookingError({
            editBookingError: `This is a blackout date, please contact support@drivado.com`,
          })
        );
        yield put(
          setEditBookingDate({
            editBookingDate: "",
          })
        );
        yield put(
          setEditBookingDate({
            editBookingDate: action.payload?.body?.bookingDate,
          })
        );
      } else {
        yield put(
          setEditBookingError({
            editBookingError: "",
          })
        );
        yield put(
          setEditBookingDate({
            editBookingDate: action.payload?.body?.bookingDate,
          })
        );
      }
    }
  } catch (error) {
    console.log(error);
  }
}

export function* watchEventAsync() {
  yield takeLatest("CREATE_EVENT", createEventSaga);
  yield takeLatest("GET_ALL_EVENTS", getAllEventsSaga);
  yield takeLatest("EDIT_EVENT", editEventSaga);
  yield takeLatest("DELETE_EVENT", deleteEventSaga);
  yield takeLatest("DATE_EXIST_WITHIN_EVENT", dateExistWithinEventSaga);
}
